export default {
  scheduled_order: 'Geplande bestelling',
  show_more: 'Meer tonen',
  show_less: 'Minder tonen',
  schedule_order: 'Bestelling inplannen',
};
